import React from "react";
import { getItem, setItem } from '../Storage';
import { Input, CodeInput, Error } from '../components';
import { StyleUtils } from '../utils';
import { Player } from '@lottiefiles/react-lottie-player';
import AuthController from '../controllers/authController';
import '../css/salient.css';
import '../css/onboarding.css';

const RESEND_SECONDS = 60;

export default class SignIn extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      code: '',
      error: '',
      display_code_input: false,
      loading_email: false,
      loading_verify: false,
      loading_resend: false,
      resend_seconds: 0,
      no_airtable_access: false
    };
    this.resend_timer = null;
  }

  componentDidMount() {

  }

  componentWillUnmount() {
    this.clear_resend_timer();
  }

  clear_resend_timer = () => {
    if (this.resend_timer) {
      clearInterval(this.resend_timer);
      this.resend_timer = null;
    }
  }

  start_resend_timer = () => {
    this.clear_resend_timer();
    this.setState({ resend_seconds: RESEND_SECONDS });
    this.resend_timer = setInterval(() => {
      let seconds = this.state.resend_seconds - 1;
      if (seconds <= 0) {
        this.clear_resend_timer();
        seconds = 0;
      }
      this.setState({ resend_seconds: seconds });
    }, 1000);
  }

  verify_code_action = async (auto_code) => {
    this.setState({ loading_verify: true, error: '' });

    let partner_name  = getItem('partner_name');
    let email_address = this.state.email;

    if (this.props.locked_email) {
      email_address = this.props.locked_email;
    }

    let code          = auto_code ? auto_code : this.state.code;
    let code_response = await AuthController.signInSignOut_Verify({ email: email_address, host_name: partner_name, code: code });
    let code_success  = code_response && code_response.success ? true : false;
    let token         = code_response && code_response.token   ? code_response.token   : '';
    let user_id       = code_response && code_response.user_id ? code_response.user_id : '';
    let error_message = code_response && code_response.error   ? code_response.error   : '';

    if (code_success && this.props.success_action) {
      setItem('token', token);
      setItem('user_id', user_id);

      let user_details = await AuthController.getLoggedInUser();

      this.setState({ loading_verify: false, error: '' })
      this.props.success_action();
    } else {
      this.setState({ loading_verify: false, error: error_message })
    }
  }

  resend_code_action = async () => {
    if (this.state.resend_seconds > 0 || this.state.loading_resend) {
      return;
    }

    let email_address = this.props.locked_email ? this.props.locked_email : this.state.email;
    let partner_name  = getItem('partner_name');

    this.setState({ loading_resend: true, error: '' });
    let sign_in_response = await AuthController.signInSignOut({ email: email_address, host_name: partner_name, short_code: true });
    let sent_success     = sign_in_response && sign_in_response.success ? true : false;
    let error_message    = sign_in_response && sign_in_response.error   ? sign_in_response.error : '';

    this.setState({ loading_resend: false, code: '', error: sent_success ? '' : error_message });
    if (sent_success) {
      this.start_resend_timer();
    }
  }

  change_email_action = () => {
    this.clear_resend_timer();
    this.setState({
      email: '',
      code: '',
      error: '',
      display_code_input: false,
      loading_email: false,
      loading_verify: false,
      loading_resend: false,
      resend_seconds: 0
    })
  }

  render_logo = () => {
    let partner  = getItem('partner');
    let logo_url = partner && partner.logo_url ? partner.logo_url : '';

    return <div className='onb-header'>
      { logo_url ? <img className='onb-logo' src={ logo_url } alt='' /> : null }
    </div>
  }

  render_button = (title, options) => {
    let is_disabled = options && options.disabled ? true : false;
    let is_loading  = options && options.loading  ? true : false;
    let show_arrow  = options && options.arrow    ? true : false;

    return <div className={ 'onb-btn' + (is_disabled ? ' is-disabled' : ' sln-pressable') }
                onClick={ () => {
                  if (is_disabled || is_loading) {
                    return;
                  }
                  if (options && options.onClick) {
                    options.onClick();
                  }
                }}>
      { is_loading ? <Player autoplay loop src={ require('../animations/white-spinner.json') } style={{ height: '20px', width: '20px' }} />
                   : <span>{ title }</span> }
      { !is_loading && show_arrow ? <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
                                      <path d='M9 6l6 6-6 6' />
                                    </svg> : null }
    </div>
  }

  render_code_input = () => {
    if (!this.state.display_code_input) {
      return null;
    }

    let code_complete  = this.state.code && this.state.code.length === 4 ? true : false;
    let seconds        = this.state.resend_seconds;
    let resend_locked  = seconds > 0 || this.state.loading_resend;
    let resend_label   = this.state.loading_resend ? 'Sending…' : (seconds > 0 ? `Resend (${ seconds }s)` : 'Resend');

    return <div className='onb-body'>
      <span className='onb-title'>Enter Code</span>
      <span className='onb-subtitle'>We’ve emailed you a verification code</span>

      <div className='onb-form'>
        <CodeInput value={this.state.code}
                   autofocus={true}
                   hide_label={true}
                   row_class='onb-code'
                   input_class='onb-code-box'
                   onChange={ (text_input) => {
                     if (text_input.length === 4) {
                       this.verify_code_action(text_input);
                     }
                     this.setState({ code: text_input })
                   }}/>

        { this.render_button('Verify Code', { disabled: !code_complete, loading: this.state.loading_verify, onClick: () => { this.verify_code_action(); } }) }
        { this.render_error_section() }

        <div className='onb-help'>
          <span>Didn’t get a code? </span>
          <span className={ 'onb-link' + (resend_locked ? ' is-disabled' : '') }
                onClick={ () => { this.resend_code_action(); } }>{ resend_label }</span>
          <br />
          <span>or check your spam folder</span>
        </div>

        { !this.props.locked_email ? <div className='onb-help-alt'>
            <span className='onb-link' onClick={ () => { this.change_email_action(); } }>Use a different email</span>
          </div> : null }
      </div>
    </div>
  }

  continue_email_action = async (email_address) => {
    if (!email_address || this.state.loading_email) {
      return;
    }

    this.setState({ loading_email: true });
    let partner_name      = getItem('partner_name');
    let sign_in_response  = await AuthController.signInSignOut({ email: email_address, host_name: partner_name, short_code: true });
    let code_sent_success = sign_in_response && sign_in_response.success ? true : false;
    let error_message     = sign_in_response && sign_in_response.error   ? sign_in_response.error : '';
    let no_airtable_access= sign_in_response && sign_in_response.no_airtable_access && sign_in_response.no_airtable_access === true ? true : false;
    this.setState({ display_code_input: code_sent_success, loading_email: false, error: error_message, no_airtable_access: no_airtable_access });
    if (code_sent_success) {
      this.start_resend_timer();
    }
  }

  render_email_input = () => {
    if (this.state.display_code_input) {
      return null;
    }

    let email     = this.state.email;
    let disabled  = false;

    if (this.props.locked_email) {
      email    = this.props.locked_email;
      disabled = true;
    }

    return <div className='onb-body'>
      <span className='onb-title'>Email Address</span>
      <span className='onb-subtitle'>Please enter your email address</span>

      <div className='onb-form'>
        <label className='onb-label' htmlFor='onb-email'>Your Email<span className='onb-label-req'>*</span></label>
        <div className='onb-field'>
          <svg className='onb-field-icon' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
            <rect x='3' y='5' width='18' height='14' rx='2' />
            <path d='M3 7l9 6 9-6' />
          </svg>
          <Input type='email'
                 id='onb-email'
                 value={email}
                 disabled={disabled}
                 input_class='onb-input'
                 style={{}}
                 container_style={{ width: '100%' }}
                 placeholder={'you@example.com'}
                 onChange={ (text_input) => {
                   this.setState({ email: text_input })
                 }}
                 onKeyDown={ (event) => {
                   if (event.key === 'Enter') {
                     this.continue_email_action(email);
                   }
                 }} />
        </div>

        { this.render_button('Continue', { arrow: true, loading: this.state.loading_email, onClick: () => { this.continue_email_action(email); } }) }
        { this.render_error_section() }
      </div>
    </div>
  }

  /*
  return <div className='flex-container-column' style={{ marginTop: 20, textAlign: 'center', fontWeight: 13, color: '#4c4c4c' }}>
    <span>Looks like you are out of credits. <a className="tos-link" style={{ color: StyleUtils.get_primary_color(), marginRight: 5 }} target="_blank" href={ training_access_url }>Add credits</a></span>
    <span>or contact <a className="tos-link" style={{ color: StyleUtils.get_primary_color(), marginRight: 5 }} target="_blank" href="mailto:support@teletails.com">support@teletails.com</a></span>
  </div>
  */

  render_error_section = () => {
    let partner               = getItem('partner');
    let is_no_airtable_access = this.state.no_airtable_access;
    let is_training_access    = partner && partner.training_enabled && partner.training_enabled === true ? true : false;
    let is_health_only_access = !is_training_access;
    let training_access_url   = partner && partner.training_access_url ? partner.training_access_url : '';
    let health_access_url     = partner && partner.health_access_url   ? partner.health_access_url   : '';

    let is_support_pets       = partner && partner.name === 'supportpets' ? true : false;

    if (is_no_airtable_access && is_support_pets) {
      return <div className='flex-container-column' style={{ marginTop: 20, textAlign: 'center', fontSize: 13, color: '#4c4c4c', fontWeight: '500' }}>
        <span><span style={{ fontWeight: 'bold' }}>Trouble logging in?</span> Please reach out to our support team <a className="tos-link" style={{ color: StyleUtils.get_primary_color(), fontWeight: 'bold' }} target="_blank" href={ 'https://www.supportpets.com/contact-us-new/#tab1/' }>here</a>.</span>
      </div>
    }

    if (is_no_airtable_access && is_training_access) {
      return <div className='flex-container-column' style={{ marginTop: 20, textAlign: 'center', fontSize: 13, color: '#4c4c4c', fontWeight: 'bold' }}>
        <span>For access, click <a className="tos-link" style={{ color: StyleUtils.get_primary_color(), marginRight: 5 }} target="_blank" href={ training_access_url }>here</a>or contact <a className="tos-link" style={{ color: StyleUtils.get_primary_color(), marginRight: 5 }} target="_blank" href="mailto:support@teletails.com">support@teletails.com</a></span>
      </div>
    }

    if (is_no_airtable_access && is_health_only_access) {
      return <div className='flex-container-column' style={{ marginTop: 20, textAlign: 'center', fontSize: 13, color: '#4c4c4c', fontWeight: 'bold' }}>
        <span>For access, click <a className="tos-link" style={{ color: StyleUtils.get_primary_color(), marginRight: 5 }} target="_blank" href={ health_access_url }>here</a>or contact <a className="tos-link" style={{ color: StyleUtils.get_primary_color(), marginRight: 5 }} target="_blank" href="mailto:support@teletails.com">support@teletails.com</a></span>
      </div>
    }

    return <div>
      <Error error={this.state.error} style={{ marginTop: 20 }} />
    </div>
  }

  render() {
    let palette    = StyleUtils.get_intro_palette();
    let root_style = {
      '--ch-accent':      StyleUtils.get_header_color(),
      '--ch-accent-text': StyleUtils.get_header_text_color_auto(),
      '--ch-button':      StyleUtils.get_button_color(),
      '--ch-button-text': StyleUtils.get_button_text_color_auto(),
      '--ch-primary':     StyleUtils.get_primary_color(),
      '--onb-btn-glow':   palette.btn_glow,
      '--onb-ring':       palette.ring,
    };

    return (
      <div className='onb-root' style={ root_style }>
        <div className='onb-card onb-card--tall'>
          { this.render_logo() }
          { this.render_email_input() }
          { this.render_code_input()  }
        </div>
      </div>
    );
  }
}
